document.addEventListener("DOMContentLoaded", () => {
    document.addEventListener(
        "click",
        (e) => {

            // Lead image button
            const leadImageButton = e.target.closest(
                "a[data-testid='add-google--btn']"
            );
            if (leadImageButton) {
                window.dataLayer.push({
                    event: "element_click",
                    item_type: "external link",
                    item_id: "https://google.com/preferences/source?q=sportingnews.com",
                    item_name: "Add Sporting News on Google",
                    cta_type: "button",
                    cta_id: "googlesource_sportingnews_nologo",
                });
            }

            // Section button
            const sectionButton = e.target.closest(
                "a[data-testid='set--add-google--btn']"
            );
            if (sectionButton) {
                window.dataLayer.push({
                    event: "element_click",
                    item_type: "external link",
                    item_id: "https://google.com/preferences/source?q=sportingnews.com",
                    item_name: "Add as preferred source on Google",
                    cta_type: "button",
                    cta_id: "googlesource_google_logo",
                });
            }

            // Footer button
            const footerButton = e.target.closest(
                "a[data-testid='footer--add-google--btn']"
            );
            if (footerButton) {
                window.dataLayer.push({
                    event: "element_click",
                    item_type: "external link",
                    item_id: "https://google.com/preferences/source?q=sportingnews.com",
                    item_name: "Add as preferred source on Google",
                    cta_type: "button",
                    cta_id: "googlesource_google_logo_footer",
                });
            }
        },
        true
    );
});
